import React, { useEffect } from "react";
import perfume from "../../assets/logo.mp4";
import { categories } from "../../data/text";
// import women from '../../assets/women.png';
// import men from '../../assets/men.png'
import women from "../../assets/women.webp";
import men from "../../assets/men.webp";

import { WhiteButton } from "../Buttons";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const Category = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full mx-auto bg-white py-[1rem] md:py-[2rem] px-1 md:px-4 overflow-x-hidden">
      {/* Categories */}
      <div className="flex flex-wrap gap-[0rem] md:gap-[2rem]  justify-start md:justify-center  items-center">
        {categories.map((category, index) => (
          <div
            key={index}
            className="relative flex flex-row md:flex-row items-center md:items-start gap-[10px] md:gap-[20px] px-4 py-2 max-w-full"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <img
              src={category.icon}
              alt={category.title}
              className="h-[40px] md:max-w-full"
              style={{ filter: "brightness(0)" }}
            />
            <div className="text-black max-w-full">
              <h1 className="text-[18px] sm:text-[20px] font-Syne font-bold">
                {category.secure}{" "}
                <span className="text-gradient-black font-Syne">
                  {category.title}
                </span>{" "}
                {category.price}
              </h1>
              <p className="text-[16px] sm:text-[18px]  font-light font-Outfit">
                {category.detail}
              </p>
            </div>

            {index !== categories.length - 1 && (
              <span
                className="hidden lg:block absolute right-[-1rem] top-1/4 h-1/2 w-[2px]"
                style={{
                  background:
                    "linear-gradient(180deg, #000000 -9.1%, #000000 54.84%, #000000 109.1%)",
                }}
              ></span>
            )}
          </div>
        ))}
      </div>

      {/* Main Promo Section */}
      <div>
        <div className="flex flex-row  gap-[10px] justify-center items-center w-full py-[1rem] md:py-[4rem]">
          {/* Men Collection */}
          <div
            className="relative w-full md:w-[450px] max-w-full h-[300px] gradient rounded-[20px] flex justify-center
            items-center md:items-start pl-[0.5rem] sm:pl-[2rem] flex-col overflow-hidden"
            data-aos="fade-right"
          >
            <img
              src={men}
              alt=""
              className="object-cover h-full w-full absolute right-0 rounded-[20px]"
            />
            <div className="absolute inset-0 bg-black/70 rounded-lg" />
            <div
              className="flex flex-col justify-center
            items-center md:items-start gap-[1rem]  z-10 text-white w-full md:w-70%"
            >
              <h1 className="font-Syne text-[1.2rem] font-Syne md:text-[2rem] font-bold ">
                Men's
              </h1>
              <p className="font-Outfit text-[14px] text-center md:text-start md:text-[18px] ">
                Discover masculine scents that exude strength, elegance, and
                timeless appeal.
              </p>
              <button
                onClick={() => navigate("/fragrance?category=men")}
                className="group flex items-center justify-center gap-2 w-[100px] md:w-[200px] py-2 md:py-3 rounded-[30px] text-black bg-white text-[14px] md:text-[18px] font-syne font-semibold hover:bg-black  transition-all duration-500 ease-in-out"
              >
                <span className="flex items-center gap-2  text-gray-700  group-hover:text-gray-800  transition-all duration-500">
                  Shop Now
                </span>
              </button>
            </div>
          </div>

          {/* Video */}
          <video
            key={perfume}
            autoPlay
            loop
            muted
            playsInline
            className="hidden md:flex w-full md:w-[450px] max-w-full h-[300px] rounded-[20px] object-fit"
            data-aos="zoom-in"
          >
            <source
              src="https://dev-designversestudios.com/video/logo.mp4"
              type="video/mp4"
            />
          </video>

          {/* Women Collection */}
          <div
            className="relative w-full md:w-[450px] max-w-full h-[300px] gradient rounded-[20px] flex justify-center items-center md:items-start pl-[0.5rem] sm:pl-[2rem] flex-col overflow-hidden"
            data-aos="fade-left"
          >
            <img
              src={women}
              alt=""
              className="object-cover h-full w-full absolute top-0 left-0 rounded-[20px] z-0"
            />
            <div className="absolute inset-0 bg-black/70 rounded-lg" />
            <div className="flex flex-col justify-center items-center md:items-start gap-[1rem]  relative z-10  w-full md:w-70% pr-[5px] md:pr-[20px]  ml-auto ">
              <h1 className="font-Syne text-[1.2rem] text-white md:text-[2rem] font-bold ">
                Women's
              </h1>
              <p className="font-Outfit text-[14px] text-center md:text-start text-white md:text-[18px] ">
                From soft florals to bold blends, find your signature scent made
                to enchant.
              </p>
              <button
                onClick={() => navigate("/fragrance?category=women")}
                className="group flex items-center justify-center gap-2 w-[100px] md:w-[200px] py-2 md:py-3 rounded-[30px] text-black bg-white text-[14px] md:text-[18px] font-syne font-semibold hover:bg-black  transition-all duration-500 ease-in-out"
              >
                <span className="flex items-center gap-2  text-gray-700  group-hover:text-gray-800  transition-all duration-500">
                  Shop Now
                </span>
              </button>
            </div>
          </div>
        </div>
        <video
          key={perfume}
          autoPlay
          loop
          muted
          playsInline
          className="flex md:hidden w-full md:w-[300px] h-[300px] rounded-[20px] object-contain"
          data-aos="zoom-in"
        >
          <source
            src="https://dev-designversestudios.com/video/logo.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  );
};

export default Category;
